import React from 'react';
import NotesMainPanel from '../../components/workspace/NotesMainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function BonnieTools() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const items = data?.bonnie?.tools || [];
  return (
    <NotesMainPanel
      title={t('bonnie.toolsTitle')}
      subtitle={t('bonnie.toolsSubtitle')}
      items={items}
      emptyTitle={t('bonnie.toolsEmpty')}
    />
  );
}
